import type { Link } from '@wix/public-schemas'
import { LinkRel } from './linksDataTypes'

export const addRelToLinkProps = (link: Link, rel?: Array<LinkRel>): Link => {
	if (rel && rel.length) {
		return { ...link, rel: rel.join(' ') }
	}
	return link
}

export const removeHash = (pageId: string) => {
	return pageId.replace('#', '')
}

export const encodeAnchorName = (anchorName: string): string => {
	// Use encodeURIComponent to handle most special characters
	// Then decode some characters that are safe in URL fragments
	return encodeURIComponent(anchorName).replace(/[!'()*]/g, (c) => {
		// These characters are safe in URL fragments and don't need to be encoded
		return c
	})
}

export const addAnchorsData = (link: Link, anchorName?: string): Link => {
	if (!anchorName || !link.href) {
		return link
	}

	const encodedAnchorName = encodeAnchorName(anchorName)
	const hrefWithAnchor = `${link.href}#${encodedAnchorName}`

	return { ...link, href: hrefWithAnchor }
}

export const toQueryString = (queryObject: Record<string, string>) =>
	Object.keys(queryObject)
		.map((key) => `${key}=${encodeURIComponent(queryObject[key])}`)
		.join('&')
